import { render, staticRenderFns } from "./SearchLabel.vue?vue&type=template&id=8b00831c&scoped=true"
import script from "./SearchLabel.vue?vue&type=script&lang=js"
export * from "./SearchLabel.vue?vue&type=script&lang=js"
import style0 from "./SearchLabel.vue?vue&type=style&index=0&id=8b00831c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b00831c",
  null
  
)

export default component.exports